import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Heading2 } from '@blueprint/ui';

export const MapContainer = styled('div')`
    width: 100%;
    height: auto;

    > div {
        width: 100%;
        height: 100%;
    }
`;

export const StyledError = styled(Heading2)(
    ({ theme }) => css`
        align-items: center;
        display: flex;
        flex-grow: 1;
        justify-content: center;
        padding: ${theme.spacing['48px']};
        text-align: center;
        width: 80%;
    `
);
